import axiosInstance from './AxiosInstance';
export const getMerchantKyc = (getData) => {
  return axiosInstance.get("user-kyc-list/list", {
    params: getData,
  });
};